const zoneNameOutline = [
  '-1px -1px 0 #000',
  '1px -1px 0 #000',
  '-1px 1px 0 #000',
  '1px 1px 0 #000',
  '-1px 0 0 #000',
  '1px 0 0 #000',
  '0 -1px 0 #000',
  '0 1px 0 #000',
].join(', ');

export const labelStyle = {
  padding: '4px 8px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: '500',
  color: 'white',
  textShadow: zoneNameOutline,
  whiteSpace: 'nowrap',
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
};